import { Routes } from '@angular/router';

// dashboard
import { AppLayout } from './layout/app-layout';
import { AuthLayout } from './layout/auth-layout';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
    {
        path: '',
        component: AppLayout,
        canActivate: [authGuard],
        loadChildren: () => import('./features/main/pages.route').then(m => m.PageRouting)
    },
    // {
    //     path: 'timesheet',
    //     component: AppLayout,
    //     loadChildren: () => import('./timesheet/timesheet.route').then(m => m.TimesheetRouting)
    // },
    // {
    //     path: 'travel',
    //     component: AppLayout,
    //     loadChildren: () => import('./travel-portal/travel.route').then(m => m.TravelRouting)
    // },
    {
        path: 'auth',
        component: AuthLayout,
        loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule)
        // children: [
        //     // Define child routes for AuthLayout here if any
        // ],
    },
];
